import { useState, useEffect, useRef } from 'react';

export function useAnimationLoop(): number {
  const [now, setNow] = useState(Date.now);
  const rafRef = useRef<number>(0);

  useEffect(() => {
    const tick = () => {
      setNow(Date.now());
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  return now;
}
